'use client'

import * as React from 'react'

import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react'
import type { CategoryHierarchy } from '@/gen/ecom'

interface HeaderContextProps {
  isMegaMenuOpen: boolean
  setIsMegaMenuOpen: Dispatch<SetStateAction<boolean>>
  isSideMenuOpen: boolean
  setIsSideMenuOpen: Dispatch<SetStateAction<boolean>>
  selectedMenuItem: string | null
  setSelectedMenuItem: Dispatch<SetStateAction<string | null>>
  megaMenuRef: React.RefObject<HTMLDivElement | null>
  menuItemsBarRef: React.RefObject<HTMLDivElement | null>
  forceClose: boolean
  setForceClose: Dispatch<SetStateAction<boolean>>
  isSearchOpen: boolean
  setIsSearchOpen: Dispatch<SetStateAction<boolean>>
  headerAppBarRef: React.RefObject<HTMLDivElement | null>
}

export const HeaderContext = React.createContext<HeaderContextProps>({
  isMegaMenuOpen: false,
  setIsMegaMenuOpen: () => false,
  selectedMenuItem: null,
  setSelectedMenuItem: () => null,
  isSideMenuOpen: false,
  setIsSideMenuOpen: () => false,
  megaMenuRef: React.createRef<HTMLDivElement | null>(),
  menuItemsBarRef: React.createRef<HTMLDivElement | null>(),
  setForceClose: () => false,
  forceClose: false,
  isSearchOpen: false,
  setIsSearchOpen: () => false,
  headerAppBarRef: React.createRef<HTMLDivElement | null>(),
})

interface HeaderContextProviderProps extends PropsWithChildren {
  catalog: CategoryHierarchy[]
}

export const CatalogContext = React.createContext<CategoryHierarchy[]>([])

const HeaderContextProvider: FC<HeaderContextProviderProps> = ({ catalog, children }) => {
  const [isMegaMenuOpen, setIsMegaMenuOpen] = React.useState(false)
  const [selectedMenuItem, setSelectedMenuItem] = React.useState<string | null>(null)
  const [isSideMenuOpen, setIsSideMenuOpen] = React.useState(false)
  const [forceClose, setForceClose] = React.useState(false)
  const [isSearchOpen, setIsSearchOpen] = React.useState(false)
  const megaMenuRef = React.useRef<HTMLDivElement | null>(null)
  const menuItemsBarRef = React.useRef<HTMLDivElement | null>(null)
  const headerAppBarRef = React.useRef<HTMLDivElement | null>(null)

  return (
    <HeaderContext.Provider
      value={{
        isMegaMenuOpen,
        setIsMegaMenuOpen,
        isSideMenuOpen,
        setIsSideMenuOpen,
        selectedMenuItem,
        setSelectedMenuItem,
        megaMenuRef,
        menuItemsBarRef,
        forceClose,
        setForceClose,
        isSearchOpen,
        setIsSearchOpen,
        headerAppBarRef,
      }}
    >
      <CatalogContext.Provider value={catalog}>{children}</CatalogContext.Provider>
    </HeaderContext.Provider>
  )
}

export default HeaderContextProvider
